module.exports = __webpack_public_path__ + "img/1.9982db6b.png";